import type { APICategory } from "~~/shared/types/category";
import type { APIPaginate } from "~~/shared/types/api";

export const useCategories = () => {
    return useAsyncData<APIPaginate<APICategory>>("northland:categories", () => smartFetch("/v1/categories", { baseTarget: "local" }), {
        server: true,
        getCachedData: (key, nuxtApp, _ctx) => (nuxtApp.isHydrating ? nuxtApp.payload.data[key] : nuxtApp.static.data[key]),
    });
};
